import SectionHeading from './SectionHeading';
import { addressTips } from '@/mocks/home';

export default function AddressChange() {
  return (
    <section id="address" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Changing Address"
          title="需要换地址时，怎么找到正确入口"
          desc="地址变化是常见的访问情况，关键是找到可靠的入口方向，而不是随便点一个链接。下面几点能帮你判断新入口是否可信。"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div className="overflow-hidden rounded-2xl border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20network%20of%20glowing%20red%20and%20amber%20connecting%20paths%20leading%20to%20one%20bright%20verified%20node%2C%20concept%20of%20finding%20the%20correct%20route%2C%20dark%20cinematic%20background%20with%20warm%20highlights%2C%20clean%20minimal%20editorial%20visual&width=900&height=760&seq=address-hongtao-04&orientation=landscape"
              alt="寻找正确访问入口的概念示意"
              className="h-auto w-full object-top"
            />
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {addressTips.map((t, i) => (
              <article key={t.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
                <div className="flex items-center justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-accent-700">
                    <i className={`${t.icon} text-xl`}></i>
                  </span>
                  <span className="font-heading text-lg font-bold text-background-400">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{t.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}